import React from 'react';
import { motion } from 'framer-motion';
export function CTA() {
  return <section className="py-32 bg-matrix-black relative overflow-hidden px-4 border-t border-matrix-green/20" data-id="element-40">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-matrix-green/10 via-matrix-black to-matrix-black" data-id="element-41"></div>

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-42">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-43">
          <h2 className="font-cinzel text-5xl md:text-7xl text-matrix-cream mb-8 drop-shadow-[0_0_15px_rgba(245,230,200,0.2)]" data-id="element-44">
            Es momento de despertar
          </h2>

          <p className="text-xl text-matrix-white/80 mb-12 font-light max-w-2xl mx-auto" data-id="element-45">
            La decisión es tuya. Puedes cerrar esta página y volver a tu vida
            normal, o puedes dar el paso y ver qué tan profunda es la madriguera
            del conejo.
          </p>

          <div id="precio" className="scroll-mt-8" data-id="element-46">
            <div className="mb-6" data-id="element-47">
              <span className="text-matrix-white/50 line-through text-xl font-light mr-3" data-id="element-48">
                $19.99
              </span>
              <span className="text-matrix-green font-cinzel text-5xl md:text-6xl font-bold drop-shadow-[0_0_15px_rgba(0,255,65,0.5)]" data-id="element-49">
                $6.39
              </span>
            </div>
            <p className="text-matrix-green/80 text-sm uppercase tracking-widest mb-8" data-id="element-50">
              Precio especial por tiempo limitado
            </p>

            <motion.a href="https://tuserenequilibrio.com/cart/51604831895873:1" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.05,
            boxShadow: '0 0 30px rgba(0,255,65,0.8)'
          }} whileTap={{
            scale: 0.95
          }} className="inline-block bg-matrix-green text-matrix-black font-inter font-bold text-2xl px-12 py-5 rounded-sm uppercase tracking-wider transition-all duration-300 shadow-[0_0_20px_rgba(0,255,65,0.4)]" data-id="element-51">
              Comprar ahora
            </motion.a>

            <p className="mt-6 text-matrix-green/60 text-sm tracking-widest uppercase" data-id="element-52">
              Acceso instantáneo • Formato Digital
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}